/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

export const isElementNull = (element: any): boolean => element == null;
export const isArrayNullOrEmpty = (array: any[]): boolean => !(array?.length > 0);
export const isStringNullOrEmpty = (str: string): boolean => !str;
